module.exports = vendor_2cebfa8f822b56fdeaad;